module.exports = __webpack_public_path__ + "static/media/redo.859b60d6.svg";